import styled from "@emotion/styled";

import { ITextProps } from "components/layout/Text";

interface IActionLinkProps extends ITextProps {
  warning?: boolean;
}

export const ActionLink = styled.button<IActionLinkProps>`
  padding: 0;
  display: inline;
  cursor: pointer;
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.warning ? props.theme.warningColor : props.theme.linkColor)
  };
  text-decoration: none;
  border: none;
  background: none;
  &:hover {
    text-decoration: underline;
  }
`;

ActionLink.defaultProps = {
  fontSize: "14px",
};
